import { InventoryDevice, PropertyPanelDevice } from '@shure/cloud/shared/models/devices';
import { DeviceModel } from '@shure/shared/angular/data-access/system-api/models';

import { AnalyticsCommonDeviceInfo, DeviceRowDataForAnalytics } from './models/common.model';

export function propertyPanelDeviceToAnalyticsDevice(devices: PropertyPanelDevice[]): AnalyticsCommonDeviceInfo[] {
	return devices.map((device) => ({
		model: device.model,
		serial: device.features.serialNumber?.serialNumber,
		mac: device.features.audioNetwork?.macAddress,
		// eslint-disable-next-line @typescript-eslint/naming-convention
		hardware_id: device.hardwareId,
		// eslint-disable-next-line @typescript-eslint/naming-convention
		network_status: device.status
	}));
}

export function inventoryDeviceToAnalyticsDevice(devices: InventoryDevice[]): AnalyticsCommonDeviceInfo[] {
	return devices.map((device) => ({
		model: device.model,
		serial: device.features.serialNumber?.serialNumber,
		mac: device.features.audioNetwork?.macAddress,
		// eslint-disable-next-line @typescript-eslint/naming-convention
		hardware_id: device.hardwareId,
		// eslint-disable-next-line @typescript-eslint/naming-convention
		network_status: device.status
	}));
}

export function deviceRowDataToAnalyticsDevice(devices: DeviceRowDataForAnalytics[]): AnalyticsCommonDeviceInfo[] {
	return devices.map((device) => ({
		model: <DeviceModel>device.model,
		serial: device.serialNumber,
		mac: device.macAddress,
		// eslint-disable-next-line @typescript-eslint/naming-convention
		hardware_id: device.hardwareId,
		// eslint-disable-next-line @typescript-eslint/naming-convention
		network_status: device.deviceStatusCellData?.status
	}));
}
